var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormControl, Skeleton, styled, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { LabelPlacement } from '../Form/FormInputProps';
import FormLabel from '../Form/FormLabel';
// Components.
var SFormControl = styled(FormControl, {
    name: 'MuiFormControl',
    shouldForwardProp: function (prop) { return !['labelPlacement', 'insets'].includes(prop.toString()); },
    overridesResolver: function (_a) {
        var labelPlacement = _a.labelPlacement, insets = _a.insets, theme = _a.theme;
        var customOverrides = theme.components.MuiFormControl.customOverrides;
        return [customOverrides["".concat(labelPlacement, "Placement")], insets && customOverrides.insets];
    },
})({});
var SFormLabel = styled(FormLabel, {
    shouldForwardProp: function (prop) { return prop !== 'labelPlacement'; },
    name: 'MuiFormControl',
    overridesResolver: function (_a) {
        var labelPlacement = _a.labelPlacement, theme = _a.theme;
        var customOverrides = theme.components.MuiFormControl.customOverrides;
        return [
            customOverrides["".concat(labelPlacement, "DisplayField")],
            customOverrides["".concat(labelPlacement)],
        ];
    },
})({});
var STypography = styled(Typography, {
    name: 'MuiFormControl',
    overridesResolver: function (_a) {
        var theme = _a.theme;
        return [theme.components.MuiFormControl.customOverrides.value];
    },
})({});
var resolveValue = function (loading, value) {
    var NOT_AVAILABLE = '---';
    if (loading) {
        return React.createElement(Skeleton, null);
    }
    if (typeof value === 'string') {
        return React.createElement(STypography, null, value !== null && value !== void 0 ? value : NOT_AVAILABLE);
    }
    return value !== null && value !== void 0 ? value : React.createElement(STypography, null, NOT_AVAILABLE);
};
var DisplayField = function (_a) {
    var _b = _a.insets, insets = _b === void 0 ? false : _b, label = _a.label, _c = _a.labelPlacement, labelPlacement = _c === void 0 ? LabelPlacement.TOP : _c, _d = _a.loading, loading = _d === void 0 ? false : _d, sx = _a.sx, value = _a.value, props = __rest(_a, ["insets", "label", "labelPlacement", "loading", "sx", "value"]);
    var resolvedValue = useMemo(function () { return resolveValue(loading, value); }, [loading, value]);
    return (React.createElement(SFormControl, __assign({}, { labelPlacement: labelPlacement, insets: insets, sx: sx }, props),
        React.createElement(SFormLabel, __assign({}, { labelPlacement: labelPlacement }), label),
        resolvedValue));
};
export default DisplayField;
